import { styled } from '@mui/material/styles'
import { LinearProgress as MuiLinearProgress, LinearProgressProps, linearProgressClasses } from '@mui/material'

interface ProgressBarProps extends LinearProgressProps {
    type?: 'standard' | 'outlined'
    background?: string
    backgroundFilled?: string
}

const LinearProgress = styled(({ ...props }: ProgressBarProps) => <MuiLinearProgress {...props} />)(
    ({ theme, background, backgroundFilled, type }) => ({
        height: type === 'outlined' ? 10 : 4,
        borderRadius: 3,
        border: type === 'standard' ? 'none' : `1px solid ${background || theme.palette.primary.main}`,
        backgroundColor: type === 'standard' ? background : theme.palette.background.default,
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 3,
            backgroundColor: backgroundFilled,
        },
    }),
)

const ProgressBar = (props: ProgressBarProps) => {
    return <LinearProgress {...props} />
}

export default ProgressBar
